import { render, staticRenderFns } from "./fp12m.vue?vue&type=template&id=4f21c6ee"
import script from "./fp12m.vue?vue&type=script&lang=js"
export * from "./fp12m.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports